/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { uniqBy } from 'lodash'

import { generateAdminFees } from './PaymongoUtils'
import { DEFAULT_PARTICIPANT_COUNT, TEAM_TYPES } from '../constants/models'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Manila')
dayjs.extend(isSameOrBefore)

export const isEventSoldOut = (items) => {
  const totalMaxParticipants = items.reduce(
    (total, i) => total + (i.maxParticipants || 0),
    0,
  )
  const totalCount = items.reduce(
    (total, i) => total + (i.categoryCount?.['count'] || 0),
    0,
  )
  return totalMaxParticipants && totalCount >= totalMaxParticipants
}

export const isCategorySoldOut = (count, maxParticipants) => {
  return maxParticipants && count >= maxParticipants
}

export const isCategoryMultisports = (value) =>
  !!value.isTriathlon ||
  [TEAM_TYPES.DUATHLON, TEAM_TYPES.TRIATHLON].includes(value.teamType)

export const getBonusCategory = (cartItems, categories) => {
  let id = ''
  let count = 0

  const uniqueCatId = uniqBy(cartItems, 'categoryId')
  if (uniqueCatId.length === 1) {
    const currentCat = Object.values(categories).filter(
      (c) =>
        (c as unknown as any).id ===
        (uniqueCatId[0] as unknown as any).categoryId,
    )

    if (
      currentCat.length &&
      (currentCat[0] as unknown as any).bonusParticipants
    ) {
      id = (uniqueCatId[0] as unknown as any).categoryId
      count = (currentCat[0] as unknown as any).bonusParticipants
    }
  }

  return { id, count }
}

const getCartItemFees = (item, categories, paymentMode) => {
  // const fee =
  //   item.categoryId in categories ? categories[item.categoryId].fee : item.fee
  // const adminFee =
  //   item.categoryId in categories
  //     ? categories[item.categoryId].adminFees[paymentMode]
  //     : item.adminFee

  let fee = item.fee
  if (item.categoryId in categories) {
    fee =
      categories[item.categoryId].earlyBirdFee &&
      dayjs().isSameOrBefore(dayjs(categories[item.categoryId].earlyBirdUntil))
        ? categories[item.categoryId].earlyBirdFee
        : categories[item.categoryId].fee
  }

  const adminFee = generateAdminFees(fee)[paymentMode]
  return { fee, adminFee }
}

export const generateCartItems = (cartItems, categories, paymentMode) => {
  const newCartItems = []
  const { count: bonusCount } = getBonusCategory(cartItems, categories)

  const catMultisports =
    cartItems.filter((cartItem) => isCategoryMultisports(cartItem))?.[0] || []
  const isMultisports = Object.keys(catMultisports).length > 0

  // teamType categories
  const catTeam =
    cartItems.filter((cartItem) =>
      Object.keys(TEAM_TYPES).includes(cartItem.teamType),
    )?.[0] || []
  const isTeam = Object.keys(catTeam).length > 0

  let total = 0

  if (isMultisports) {
    const { fee, adminFee } = getCartItemFees(
      catMultisports,
      categories,
      paymentMode,
    )
    total = fee + adminFee
  } else if (isTeam) {
    const { fee, adminFee } = getCartItemFees(catTeam, categories, paymentMode)
    total = fee + adminFee
  }

  cartItems.forEach((item, index) => {
    let isBonus = false
    if (cartItems.length > DEFAULT_PARTICIPANT_COUNT && bonusCount > 0)
      isBonus = index + 1 > DEFAULT_PARTICIPANT_COUNT

    // const isBonus = cartItems.length - bonusCount - 1 < index
    const { fee, adminFee } = getCartItemFees(item, categories, paymentMode)
    newCartItems.push({
      ...item,
      fee,
      adminFee,
      isBonus,
    })

    if (!isMultisports && !isTeam && !isBonus)
      total += (fee + adminFee) * item.quantity
  })

  return { items: newCartItems, total, bonusCount }
}

export const getItemFee = (category) => {
  let adminFees = generateAdminFees(category.fee)
  if (
    category.earlyBirdUntil &&
    dayjs().isSameOrBefore(dayjs(category.earlyBirdUntil))
  ) {
    if ('earlyBirdFee' in adminFees)
      adminFees = generateAdminFees(category.earlyBirdFee)
  }

  const fee =
    category.earlyBirdUntil &&
    category.earlyBirdFee &&
    dayjs().isSameOrBefore(dayjs(category.earlyBirdUntil))
      ? category.earlyBirdFee
      : category.fee

  return { adminFees, fee }
}

export const getUserOnsiteEvents = (attributes) => {
  if (!attributes) return []
  if (!('custom:onsite_events' in attributes)) return []

  const events = attributes['custom:onsite_events'].split(',')
  return events
}
